import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class NetworkStatusService {
  private onlineStatus = new BehaviorSubject<boolean>(navigator.onLine);
  constructor() { 
    window.addEventListener('online', () => this.updateNetworkStatus(true));
    window.addEventListener('offline', () => this.updateNetworkStatus(false));
  }

  private updateNetworkStatus(status: boolean) {
    this.onlineStatus.next(status);
  }

  get isOnline(): Observable<boolean> {
    return this.onlineStatus.asObservable();
  }

  get currentStatus(): boolean {
    return this.onlineStatus.value;
  }
}
